import React, { useEffect } from 'react';
import AOS from 'aos';
import img_simulation_proposal_04_1 from '../../images/simulation_proposal_04_1.png';
import img_KneeP from '../../images/KneeP.jpg';
import img_ap3 from '../../images/ap3.png';
import img_ap4 from '../../images/ap4.png';
import img_workflow_5_surgery_1 from '../../images/workflow_5_surgery_1.png';
import img_time_essential_clock from '../../images/time_essential_clock.jpg';
import 'aos/dist/aos.css';

const processSteps = [
  {
    step: '01',
    title: 'CT Scan of Knees',
    description: 'CT scan center uploads the RAW DiCom files to ARTHRO3D Server, without processing or reporting.',
    image: img_simulation_proposal_04_1
  },
  {
    step: '02',
    title: '3D Bone Modeling',
    description: '3D Bone is created from the uploaded CT scan files.',
    image: img_KneeP
  },
  {
    step: '03',
    title: 'Surgical Landmarks',
    description: 'Surgical landmarks are selected.',
    image: img_ap3
  },
  {
    step: '04',
    title: 'Perfect Match of implant is obtained for the knee',
    description: 'Above created 3D Bone Model and Landmarks can be now seen on the surgeon’s dashboard.',
    image: img_ap4
  },
  {
    step: '05',
    title: 'On Table Navigation',
    description: 'The surgeon can now perform Robotic 3D planning without the pressures of the operation theatre....',
    image: img_workflow_5_surgery_1
  },
  {
    step: '06',
    title: 'Time is most essential',
    description: 'Since the entire process is about ‘pre-planning’ the total time inside the OT is less and hence it is a big saving for any surgeon',
    image: img_time_essential_clock
  }
];

const TheProcess = () => {
  useEffect(() => {
    AOS.init({ duration: 1500 });
  }, []);

  return (
    <div style={{ overflow: 'hidden' }}>
      <div className='container my-5'>
        <div className='text-center mb-5' data-aos='fade-up'>
          <h2 className='display-2 fw-bold text-dark' style={{ letterSpacing: '-1px' }}>The Process</h2>
        </div>

        <div className='col-12 m-auto'>
          {processSteps.map((step, index) => (
            <React.Fragment key={index}>
              <div
                className='row col-12 m-auto align-items-center py-4 px-2 rounded-4 process-step-item'
                data-aos='fade-up'
                style={{ transition: 'all 0.3s ease' }}
              >
                {/* Step Title (Left) */}
                <div className='col-lg-3 col-md-3 col-12 text-start pe-md-3'>
                  <span
                    className='badge mb-2 px-2 py-1 rounded-pill'
                    style={{
                      background: '#eff6ff',
                      color: '#1e3a8a',
                      border: '1px solid #bfdbfe',
                      fontSize: '11px',
                      fontWeight: 700,
                      letterSpacing: '1.2px'
                    }}
                  >
                    STAGE {step.step}
                  </span>
                  <h3
                    className='fs-3 fw-bold mb-0 text-dark'
                    style={{ color: '#0f172a', lineHeight: '1.3' }}
                  >
                    {step.title}
                  </h3>
                </div>

                {/* Center Image Frame */}
                <div className='col-lg-5 col-md-5 col-12 my-3 my-md-0 px-md-3 text-center'>
                  <div
                    className='overflow-hidden rounded-4 shadow-sm d-flex align-items-center justify-content-center'
                    style={{
                      width: '80%',
                      height: '175px',
                      background: '#090e1a',
                      border: '1px solid rgba(30, 58, 138, 0.15)',
                      boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)'
                    }}
                  >
                    <img
                      src={step.image}
                      alt={step.title}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center',
                        display: 'block',
                      }}
                    />
                  </div>
                </div>

                {/* Step Description (Right) */}
                <div className='col-lg-4 col-md-4 col-12 text-start ps-md-4'>
                  <p
                    className='mb-0 fw-medium'
                    style={{
                      color: '#334155',
                      fontSize: '18px',
                      lineHeight: '1.65',
                      letterSpacing: '0.2px'
                    }}
                  >
                    {step.description}
                  </p>
                </div>
              </div>

              {index !== processSteps.length - 1 && (
                <hr
                  className='m-0 my-2'
                  style={{ borderColor: '#e2e8f0', opacity: 0.8 }}
                  data-aos='fade-up'
                />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TheProcess;

